import { RouterProvider, createRouter } from '@tanstack/react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { routeTree } from './routeTree.gen.js';
import { ApiError } from './lib/api.js';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: (failureCount, error) => {
        // Don't retry auth or client errors
        if (error instanceof ApiError && error.statusCode < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      onError: (error) => {
        // Global 401 handler: token expired — router will redirect via beforeLoad
        if (error instanceof ApiError && error.statusCode === 401) {
          queryClient.setQueryData(['auth', 'me'], null);
        }
      },
    },
  },
});

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
